import type { GetNotificationById200BasicInfo } from './getNotificationById200BasicInfo';
import type { GetNotificationById200Data } from './getNotificationById200Data';
import type { GetNotificationById200Source } from './getNotificationById200Source';
import type { GetNotificationById200Status } from './getNotificationById200Status';
import type { GetNotificationById200Target } from './getNotificationById200Target';

/**
 * 알림 응답 데이터
 */
export type GetNotificationById200 = {
  basicInfo?: GetNotificationById200BasicInfo;
  /** 알림 추가 데이터 (유형에 따라 다름) */
  data?: GetNotificationById200Data;
  /** 알림 소스 정보 */
  source?: GetNotificationById200Source;
  /** 알림 상태 정보 */
  status?: GetNotificationById200Status;
  /** 알림 대상 정보 */
  target?: GetNotificationById200Target;
};
